// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__iuEHM","sendOtp":"AuthorizeToLogin_sendOtp__2GNTq"};